import CallbackPage from "../components/reuseableComponents/auth/CallbackPage";
import CypressAuth from "../components/reuseableComponents/auth/CypressAuth";
import HomePage from "../components/public/HomePage";
import NotAuthorized from "../components/reuseableComponents/auth/NotAuthorized";
import PublicPage from "../components/public/PublicIndex";
import ReportsHomePage from "../components/archive/ReportsHomePage";
import RequestPortalAccess from "../components/public/RequestPortalAccess";
import RequestAccess from "../components/public/RequestAccess";
import PortalAccessForm from "../components/public/PortalAccessForm";
import StaffAccessForm from "../components/public/StaffAccessForm";
import WaterSystemDetailedInfoPage from "../components/public/WaterSystemDetailedInfoPage";
import WaterMonitoringPage from "../components/public/WaterMonitoringPage";

export const publicRoutes = [
  {
    path: "/",
    component: HomePage,
    selectedSystemRouteToItemCode: "WATER_MONITORING"
  },
  {
    path: "/callback",
    component: CallbackPage
  },
  {
    path: "/cypress-auth",
    component: CypressAuth
  },
  {
    path: "/public-index",
    component: PublicPage
  },
  {
    path: "/reports/:systemId",
    component: ReportsHomePage
  },
  {
    path: "/public/request-portal-access",
    component: RequestPortalAccess
  },
  {
    path: "/public/request-access",
    component: RequestAccess
  },
  {
    path: "/public/portal-access-form",
    component: PortalAccessForm
  },
  {  
    path: "/public/staff-access-form",
    component: StaffAccessForm
  },
  {
    path: "/public/staff-access-form",
    component: RequestAccess
  },
  {
    path: "/not-authorized",
    component: NotAuthorized
  },
  {
    path: "/home/water-system-detailedInfo",
    component: WaterSystemDetailedInfoPage,
    requiresWaterSystem: true
  },
  {
    path: "/home/water-monitoring",
    component: WaterMonitoringPage,
    requiresWaterSystem: true
  }
];
